import { useZero } from "@rocicorp/zero/react";
import { useCallback } from "react";
import { signOut } from "../components/SignIn/lib/sso";
import { apiUrl } from "../lib/tenantOrigin";

export function useLogout() {
  const z = useZero();
  const externalApiUrl = apiUrl();
  return useCallback(async () => {
    await z.delete();
    await signOut(externalApiUrl);
  }, [z, externalApiUrl]);
}
